import React from "react";
import { LayoutContainer } from "./layout.styles";

const Layout = ({ children }) => {
  return <LayoutContainer>{children}</LayoutContainer>;
};

export default Layout;
